import React from 'react';
import DefaultAvatar from 'assets/svgs/common/default-avatar.svg';
import EmailIcon from 'assets/svgs/common/mail.svg';
import UserIcon from 'assets/svgs/common/user-icon.svg';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {useSelector} from 'react-redux';

const basicUserSelector = makeSelectBasicUser();
const SidebarProfile = ({onClick}) => {
  const userDetails = useSelector(basicUserSelector);

  return (
    userDetails && (
      <div
        className="profile-img text-center pt-5 sidebar-profile"
        onClick={onClick}
        aria-hidden
      >
        <img
          height="100"
          src={userDetails.avatar ? `${userDetails.avatar}` : DefaultAvatar}
          alt="user"
        />
        <ul className="pl-1 text-left mt-5 pt-2">
          <li>
            <span className="mr-3">
              <img src={UserIcon} alt="" width="14" />
            </span>
            {`${userDetails.firstName || ''} ${userDetails.lastName || ''}`.trim() || 'User'}
          </li>
          <li>
            <span className="mr-3">
              <img src={EmailIcon} alt="" width="15" />
            </span>
            {userDetails.email}
          </li>
        </ul>
      </div>
    )
  );
};

export default SidebarProfile;
